/**
 * Glasnu montagestappen — beheert het afspelen van de instructieclips.
 *
 * De clips staan in de HTML op autoplay/loop, zodat ze ook zonder JavaScript
 * lopen. Dit script doet twee dingen die HTML niet kan:
 *   1. bij prefers-reduced-motion alles stilzetten op het eerste beeld;
 *   2. clips buiten beeld pauzeren, zodat een pagina met dertig video's
 *      niet permanent dertig decoders open houdt.
 */
(() => {
  const videos = document.querySelectorAll('.mstep__video');
  if (!videos.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const applyReducedMotion = () => {
    if (!reduceMotion.matches) return;
    videos.forEach((video) => {
      video.autoplay = false;
      video.pause();
    });
  };

  applyReducedMotion();
  reduceMotion.addEventListener('change', applyReducedMotion);

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!reduceMotion.matches) video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  videos.forEach((video) => observer.observe(video));
})();
